import { render, staticRenderFns } from "./NotTransmittingObu.vue?vue&type=template&id=03c47f88&scoped=true&"
import script from "./NotTransmittingObu.vue?vue&type=script&lang=js&"
export * from "./NotTransmittingObu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c47f88",
  null
  
)

export default component.exports